import type { VariantCategories } from "./Variant/variantCategories";
import type { ticketState } from "modules/ticket";

type VariantObject = Record<number, ticketState["eventGoods"]>;

type Input = {
  variantList: ticketState["eventGoods"];
};
type Output = VariantCategories;
type ConvertToVariantCategories = (input: Input) => Output;

/**
 * @description
 * データ構造がグッズ詳細の ui 改修前の状態のまま、新しい ui に対応させるための一時的な関数
 * 追々は管理画面を改修し、 ui に即したデータ構造になる
 * TODO: データの並びやグルーピングの精査 https://github.com/balus-co-ltd/spwn/issues/11377
 *   グルーピングするには情報が足りてない
 *   並びは priority を使う
 *     https://www.notion.so/balusco/2026-02-20-goods-30d98eee078b80f98f45cd1c544e08f0?source=copy_link#30d98eee078b8046be63e63025866602
 */
export const convertToVariantCategories: ConvertToVariantCategories = (
  input
) => {
  const { variantList } = input;
  const variantObject = variantList.reduce<VariantObject>(
    (previousValue, currentValue) => {
      if (currentValue === undefined) return previousValue;
      const { class: classId } = currentValue;
      if (classId === undefined) return previousValue;
      const targetProperty = previousValue[classId];
      if (Array.isArray(targetProperty)) {
        targetProperty.push(currentValue);
        return previousValue;
      }

      previousValue[classId] = [currentValue];
      return previousValue;
    },
    {}
  );
  const variantCategories: VariantCategories = Object.entries(
    variantObject
  ).sort(([aKey], [bKey]) => {
    if (aKey > bKey) return 1;
    if (aKey < bKey) return -1;
    return 0;
  });

  return variantCategories;
};
